module.exports = __webpack_public_path__ + "static/media/powered.49911b7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/powered.svg
// module id = 649
// module chunks = 1